"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useBannerProductListingContext = exports.defaultBannerProductListingContextValues = exports.BannerproductListingContext = exports.BannerProductListingProvider = void 0;
var _react = require("react");
var _constants = require("../components/BannerProductListing/constants");
var _useGetPaginatedData = require("../components/BannerProductListing/utils/useGetPaginatedData");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore next -- No need to test default values.
const defaultBannerProductListingContextValues = exports.defaultBannerProductListingContextValues = {
    data: null,
    pageId: '',
    content: null,
    appliedFacets: [],
    setAppliedFacets: ()=>{},
    orderBy: _constants.DEFAULT_ORDER_BY,
    setOrderBy: ()=>{},
    getFacets: async ()=>[],
    getData: async ()=>undefined,
    loadMoreItems: async ()=>{},
    isLoadingMore: false,
    isRefreshing: false,
    enableFetch: ()=>{}
};
const BannerproductListingContext = exports.BannerproductListingContext = /*#__PURE__*/ (0, _react.createContext)(defaultBannerProductListingContextValues);
const { Provider } = BannerproductListingContext;
const BannerProductListingProvider = (param)=>{
    let { children, isPLP, pageId, data, getFacets, getData, query } = param;
    const [skip, setSkip] = (0, _react.useState)(_constants.SERVER_PAGINATION_LIMIT_ROWS);
    const [paginationLoading, setPaginationLoading] = (0, _react.useState)(false);
    const [sortLoading, setSortLoading] = (0, _react.useState)(false);
    const [appliedFacets, setAppliedFacets] = (0, _react.useState)([]);
    const [orderBy, setOrderBy] = (0, _react.useState)(_constants.DEFAULT_ORDER_BY);
    const { content, loadMoreItems, isRefreshing, isLoadingMore, enableFetch } = (0, _useGetPaginatedData.useGetPaginatedData)({
        getData,
        data,
        appliedFacets,
        orderBy,
        pageId: pageId !== null && pageId !== void 0 ? pageId : ''
    });
    const value = (0, _react.useMemo)(()=>({
            query,
            data,
            pageId: pageId !== null && pageId !== void 0 ? pageId : '',
            content,
            skip,
            setSkip,
            paginationLoading,
            setPaginationLoading,
            isPLP,
            sortLoading,
            setSortLoading,
            appliedFacets,
            setAppliedFacets,
            orderBy,
            setOrderBy,
            getFacets,
            getData,
            loadMoreItems,
            isLoadingMore,
            isRefreshing,
            enableFetch
        }), [
        query,
        data,
        pageId,
        content,
        skip,
        paginationLoading,
        isPLP,
        sortLoading,
        appliedFacets,
        orderBy,
        getFacets,
        getData,
        loadMoreItems,
        isLoadingMore,
        isRefreshing,
        enableFetch
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Provider, {
        value: value,
        children: children
    });
};
exports.BannerProductListingProvider = BannerProductListingProvider;
const useBannerProductListingContext = ()=>(0, _react.useContext)(BannerproductListingContext);
exports.useBannerProductListingContext = useBannerProductListingContext;
